import { render } from "./SolucaoModalHistoricoIntegracao.vue?vue&type=template&id=da4a0882"
import script from "./SolucaoModalHistoricoIntegracao.vue?vue&type=script&lang=js"
export * from "./SolucaoModalHistoricoIntegracao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__